import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "snackbar-content" }
const _hoisted_2 = { class: "exit-header-title" }

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import AdminLayout from './components/layout/AdminLayout.vue';
import StaffLayout from './components/layout/StaffLayout.vue';
import MemberLayout from './components/layout/MemberLayout.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();

// 역할 기반 동적 레이아웃 선택
// 매니저 이상(60+)은 관리자와 같은 AdminLayout. 직원(40~59)만 StaffLayout.
const resolvedLayout = computed(() => {
  if (route.meta.layout) return route.meta.layout;

  const isLoggedIn = store.getters.isLoggedIn;
  const roleLevel = Number(store.getters.actualRoleLevel || store.getters.roleLevel || 0);
  const isImpersonating = store.getters.isImpersonating;

  if (route.meta.roleBasedLayout && isLoggedIn) {
    if (roleLevel >= 60) return AdminLayout;
    if (roleLevel >= 40) return StaffLayout;
  }

  if (route.meta.memberLayout && isLoggedIn) {
    if (isImpersonating) {
      if (roleLevel >= 60) return AdminLayout;
      if (roleLevel >= 40) return StaffLayout;
    }
    return MemberLayout;
  }

  // 4) 기본 v-app
  return 'v-app';
});

// 레이아웃 존재 여부
const hasLayout = computed(() => resolvedLayout.value !== 'v-app');

// 스낵바 상태 가져오기
const snackbar = computed(() => store.getters.snackbar);

// 대리 로그인 관련
const isImpersonating = computed(() => store.getters.isImpersonating);
const originalUser = computed(() => store.getters.originalUser);
const currentUser = computed(() => store.getters.currentUser);
const exitDialog = ref(false);

// 스낵바 숨기기 함수
const hideSnackbar = () => {
  store.commit('hideSnackbar');
};

// 대리 로그인 종료 (확인 다이얼로그 열기)
const exitImpersonation = () => {
  exitDialog.value = true;
};

// 복귀 확인
const confirmExit = async () => {
  await store.dispatch('exitImpersonation');
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(resolvedLayout.value), {
    class: _normalizeClass({ 'has-impersonate-banner': isImpersonating.value && !hasLayout.value })
  }, {
    default: _withCtx(() => [
      (!hasLayout.value)
        ? (_openBlock(), _createBlock(_component_v_main, {
            key: 0,
            class: _normalizeClass(["app-main", { 'has-impersonate-banner': isImpersonating.value }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.value.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snackbar.value.show) = $event)),
        color: snackbar.value.color,
        timeout: snackbar.value.timeout,
        location: "bottom",
        class: "global-snackbar"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: hideSnackbar,
            icon: "mdi-close",
            size: "small"
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(snackbar.value.text), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color", "timeout"]),
      _createVNode(_component_v_dialog, {
        modelValue: exitDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((exitDialog).value = $event)),
        "max-width": "380px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "exit-dialog" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "exit-header" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      class: "mr-2",
                      color: "warning"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("mdi-arrow-left-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createTextVNode(" 권한 복귀 ", -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "exit-close",
                    "aria-label": "닫기",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (exitDialog.value = false))
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "exit-body" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(originalUser.value?.name), 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" 계정으로 돌아가시겠습니까?", -1))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "exit-actions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    class: "btn-cancel",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (exitDialog.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("취소", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "btn-confirm",
                    onClick: confirmExit
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("복귀하기", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})